import { makeRequestWithToken } from '../services';
import { AxiosRequestConfig } from 'axios';

function appendArrayToFormData(formData: FormData, key: string, array: number[] | string[]) {
  array.forEach((value) => formData.append(key, value.toString()));
}

class Feeds {
  async all_feeds(data: any = {}): Promise<any> {
    try {
      const params = {};
      const res = await makeRequestWithToken.get('posts', params);
      return res.data?.data;
    } catch (error) {
      return error;
    }
  }

  async CreateNewFeed(data: any, onProgress?: (progress: number) => void): Promise<any> {

    const formdata = new FormData();

    formdata.append('post_type', data.post_type ?? 'tweet');
    formdata.append('content', data.text_content);

    if (data.title) formdata.append('title', data.title);
    if (data.location) formdata.append('location', data.location);
    if (data.amount) formdata.append('amount', String(data.amount));
    if (data.frequency) formdata.append('frequency', data.frequency);
    if (data.start_date) formdata.append('start_date', data.start_date);
    if (data.deadline_date) formdata.append('deadline_date', data.deadline_date);
    if (data.ride_user_type) formdata.append('ride_user_type', data.ride_user_type);
    if (data.pickup_location) formdata.append('pickup_location', data.pickup_location);
    if (data.destination) formdata.append('destination', data.destination);
    if (data.task_type) formdata.append('task_type', data.task_type);
    if (data.address) formdata.append('address', data.address);
    if (data.trip_time) formdata.append('trip_time', data.trip_time);
    if (data.start_time) formdata.append('start_time', data.start_time);

    if (data.images && data.images.length > 0) {
      data.images.forEach((image: File) => {
        formdata.append('image_files[]', image);
      });
    }

    if (data.audio) formdata.append('audio_files[]', data.audio);

    if (data.videos && data.videos.length > 0) {
      data.videos.forEach((video: File) => {
        formdata.append('video_files[]', video);
      });
    }

    appendArrayToFormData(formdata, 'community_ids[]', data.selected_community);

    if (data.poll_options && data.poll_options.length > 0)
      appendArrayToFormData(formdata, 'poll_options[]', data.poll_options);

    formdata.forEach((value, key) => {
      console.log(`${key}:`, value);
    });

    const config: AxiosRequestConfig = {
      onUploadProgress: (progressEvent: any) => {
        if (progressEvent.total && onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    };

    // No try/catch here — let errors bubble up to the caller
    return await makeRequestWithToken.post('post/create', formdata, config);
  }

  async repost(data: any): Promise<any> {

    return await makeRequestWithToken.post('post/repost', data);
  }
}

const feeds_api = new Feeds();
export default feeds_api;